<template>
  <div>
    <nav-breadcrumb :menu="[{label: '待放款列表'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="未完成" name="Approved" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="已完成" name="Completed" />
      <el-tab-pane label="作废" name="Void" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%">
      <data-table
        :table-data="tableDataDetail"
        :columns="columnsDetail"
        :is-pagination-show="false"
      />
      <panel v-if="financingDetail.z__applicationStatus== 'Failed'">
        <sms-code :params="{pay__applicationId: financingDetail.pay__applicationId}" :api="xhr.sendAllinpaySMS" v-model="checkCode" :tips="'系统会给'+ financingDetail.z__checkPhone+'的手机发送动态验证码'"></sms-code>
      </panel>
      <div class="tr xzmt" v-if="financingDetail.z__applicationStatus== 'Failed'">
        <el-button type="primary" @click="onSubmit()">重新提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import PayFinancingFangComponent from '../components/PayFinancingFangComponent'
  import DataTable from '../../components/DataTable'
  import {formatMoney} from "../../filters/CommonFilters";
  import SmsCode from "../../components/SmsCode";
  export default {
    name: "FinancingList",
    components: {SmsCode},
    data(){
      return{
        xhr,
        showsmsCode :'false',
        checkCode:'',
        applicationStatus:"Approved",
        dialogVisible :false,
        columnsDetail:[
          {
            type: 'index'
          },
          {
            label: '请求时间',
            field: 'queryTime',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
          },

          {
            label: '请求报文',
            field: 'requestMsg',

          },
          {
            label: '响应报文',
            field: 'responseMsg',
          },
          {
            label: '交易状态',
            field: 'responseCode',
            formatter: (r,c,v) => {
              return v
            },
          },
          {
            label: '错误信息',
            field: 'errorMsg',
          },

        ],
        tableDataDetail: {
          count: 0,
          data: []
        },
        financingDetail: {
        },
        tableData: {
          count: 0,
          data: []
        },
        page: 1,
        pageSize: 20,
        actions: [
        ],
        filters: {
          labelWidth: '150px',
          form: {
            fi__transactionNo:'',
            c__customerName:'',
          },
          columns: [
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'c__customerName',
            },
            {
              label: '贷款编号',
              component: 'el-input',
              field: 'fi__transactionNo',
            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          }
        }
      }
    },
    computed:{
      columns: function(){
        return [
          {
            type: 'index'
          },
          {
            label: '申请编号',
            field: 'pay__applicationNo'
          },

          {
            label: '客户姓名',
            field: 'c__customerName'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '申请放款金额',
            field: 'pay__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '申请放款日期',
            field: 'pay__paymentDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
         /* {
            label: '实际放款日期',
            field: 'pay__paymentDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },*/
          {
            label: '放款方式',
            field: 'pay__channel',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '状态',
            field: 'pay__applicationStatus',
            formatter: function (r,c,v) {
             if(v=='Approved'){
               if(r.pay__channel=='TLT'){
                 if(r.t__applicationStatus=='Pending Approval'){
                   return '等待复核'
                 }
                 if(r.t__applicationStatus=='Approved'){
                   return '已复核，等待放款'
                 }
                 if(r.t__applicationStatus==null){
                   return '等待发起'
                 }
               }else{
                 if(r.t__applicationStatus==null){
                   return '等待登记'
                 }
               }


               if(r.t__applicationStatus=='Failed'){
                 return '放款失败'
               }

             }
              if(v=='Completed'){
                return '放款完成'
              }
              if(v=='Void'){
                return '作废'
              }

            }
          },
          {
            label: '操作',
            opts:[
              {
                label: '放款日志',
                class: 'el-icon-document',
                clickHandler: (index, row) => {
                  this.dialogVisible = true
                  this.getViewAllinpayInfo(row.pay__applicationId)
                  /* this.$router.push({
                     name: 'PayFinancingTLT1View',
                     query: {
                       'applicationId': row.fi__applicationId,

                     }
                   })*/

                },
                conditions: row=> {
                  return /*(row.pay__applicationStatus == 'Completed'|| row.t__applicationStatus == 'Failed') && */row.pay__channel == 'TLT'

                }
              },
              {
                label: '发起',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.$router.push({
                    name: 'PayFinancingTLT1View',
                    query: {
                      'applicationId': row.pay__applicationId,

                    }
                  })

                },
                conditions: row=> {
                  return row.t__hasRole1 == 'true'&& row.t__check1==null && row.pay__channel == 'TLT'&&row.pay__applicationStatus=="Approved"

                }
              },
              {
                label: '复核',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.$router.push({
                    name: 'PayFinancingTLT2View',
                    query: {
                      'applicationId': row.pay__applicationId,

                    }
                  })

                },
                conditions: row=> {
                  return row.t__hasRole2 == 'true'&&row.t__check1=='Y'&&row.t__check2=='N'&&row.pay__channel == 'TLT'

                }
              },
              {
                label: '放款登记',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.$router.push({
                    name: 'PayFinancingBANKTRANSFERView',
                    query: {
                      'applicationId': row.pay__applicationId,

                    }
                  })
                },
                conditions: row=> {
                  return row.pay__channel == 'BANKTRANSFER'&&row.pay__applicationStatus == 'Approved'&&row.fi__transactionStatus == 'Ready'

                }
              },
              {
                label: '作废',
                class: 'el-icon-error',
                clickHandler: (index, row) => {
                  this.$confirm("是否确定作废数据？").then(()=> {
                    xhr.VoidFinancingPaymentApplication(
                      {
                        'pay.applicationId': row.pay__applicationId,
                      },
                      res => {
                        try {
                          if (res.data.status == 'success') {
                            this.getData()
                          } else {

                            this.$message.error(res.data.msgs[0].text)
                          }

                        } catch (e) {

                          this.$message.error(error.msgs[0].text)

                        }
                      }
                    )
                  })
                    .catch(()=> {

                    })
                },
                conditions: row=> {
                  return (row.t__applicationStatus =='Failed'|| row.t__applicationStatus ==null)&&(row.t__hasRole1 == 'true'||row.t__hasRole2 =='true')&&row.pay__applicationStatus=='Approved'&&row.fi__transactionStatus == 'Ready'

                }
              },


            ]
          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.pay.applicationStatus' : this.applicationStatus,
            'xlist.search.pay.applicationStatus.op' : 'in',
            'xlist.sort.dataField': 'pay.paymentDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    components: {
      DataTable,
      PayFinancingFangComponent
    },

    watch: {
      filterParams: function () {
        this.getData()
      },
    },

    mounted() {
      this.getData()
    },
    methods: {
      getData: function () {
        xhr.getFinancingPaymentForProcessing(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.tableData = res.data
            } catch (e) {

            }
          })
      },
      getViewAllinpayInfo: function (applicationId) {
        xhr.getViewAllinpayInfo(
          Object.assign({
            'applicationId':applicationId
          }, {},{}),
          res => {
            try {
              if (res.data.status == 'success') {
                this.tableDataDetail = {
                  count: 0,
                  data: []
                }
                this.checkCode = ''
                this.financingDetail = res.data.data
                res.data.data.detail.forEach(item => {
                  this.tableDataDetail.data.push({
                    'queryTime': item.i__createdDate,
                    'requestMsg': item.i__requestMsg,
                    'responseMsg': item.i__responseMsg,
                    'responseCode': item.i__responseCode,
                    'errorMsg': item.i__errorMsg,
                  })
                  xhr.getAllinpayQueryLogList(
                    Object.assign({
                      'i.requestId': item.i__requestId
                    }, {}, {}),
                    ress => {
                      try {
                        if (ress.data.status == 'success') {
                          ress.data.forEach(item1 => {
                            this.tableDataDetail.data.push({
                              'queryTime': item1.log__queryTime,
                              'requestMsg': item1.log__requestMsg,
                              'responseMsg': item1.log__responseMsg,
                              'responseCode': item1.log__responseCode,
                              'errorMsg': item1.log__errorMsg,
                            })
                          })
                        }
                      } catch (e) {

                      }
                    })

                })
                console.log(this.tableDataDetail)
              }
            } catch (e) {

            }
          })
      },
      onSubmit:function () {
            if(this.checkCode){

            }else{
              this.$alert('请填写验证吗')
              return false
            }
            let onSubmitFrom = {
            }
            onSubmitFrom.pay__applicationId = this.financingDetail.pay__applicationId
            onSubmitFrom.t__checkCode = this.checkCode
            xhr.updateAllinpayRetry(onSubmitFrom, res=> {
              try {
                if (res.data.status == 'success') {

                  this.$router.push({
                    path: 'List'
                  })
                }
              } catch (e) {
              }
            })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/PayFinancingList.vue